import React, { useState } from 'react';
import { useAuth } from '../App';
 
export default function Login({ deaktivovan }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [heslo, setHeslo] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, heslo);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div style={{
      minHeight: '100vh', background: '#111111',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20, fontFamily: 'DM Sans, sans-serif'
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div style={{ width: 44, height: 44, background: '#2d6a4f', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>⏱</div>
            <span style={{ fontFamily: 'DM Serif Display, serif', fontSize: 28, color: '#fff', letterSpacing: '-0.5px' }}>Výkazy práce</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }}>Evidence pracovní doby</p>
        </div>
 
        <div style={{ background: '#1a1a1a', borderRadius: 20, padding: 36, border: '1px solid rgba(255,255,255,0.08)' }}>
          <h2 style={{ color: '#fff', fontSize: 20, fontWeight: 600, marginBottom: 28 }}>Přihlášení</h2>

          {deaktivovan && (
            <div style={{ background: '#fde8e6', color: '#c0392b', borderRadius: 8, padding: '10px 14px', fontSize: 13, fontWeight: 500, marginBottom: 20 }}>
              Váš účet byl deaktivován. Kontaktujte prosím HR.
            </div>
          )}
 
          {error && (
            <div style={{ background: '#fde8e6', color: '#c0392b', borderRadius: 8, padding: '10px 14px', fontSize: 13, fontWeight: 500, marginBottom: 20 }}>{error}</div>
          )}
 
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.5)' }}>E-mail</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="vas@email.cz" required
                style={{ background: '#111', color: '#fff', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px', fontSize: 15, fontFamily: 'DM Sans, sans-serif', outline: 'none' }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.5)' }}>Heslo</label>
              <input type="password" value={heslo} onChange={e => setHeslo(e.target.value)} placeholder="••••••••" required
                style={{ background: '#111', color: '#fff', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px', fontSize: 15, fontFamily: 'DM Sans, sans-serif', outline: 'none' }} />
            </div>
            <button type="submit" disabled={loading}
              style={{ background: '#2d6a4f', color: '#fff', border: 'none', borderRadius: 10, padding: '13px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, marginTop: 4, fontFamily: 'DM Sans, sans-serif' }}>
              {loading ? 'Přihlašuji…' : 'Přihlásit se'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
